module.exports = __webpack_public_path__ + "static/img/qmwallet2-discount-bg.b15763c8.png";